import { render, staticRenderFns } from "./Iiko.vue?vue&type=template&id=3cf52694&"
import script from "./Iiko.vue?vue&type=script&lang=js&"
export * from "./Iiko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports